<template>
    <v-dialog
        v-model="showDialog"
        width="600"
        persistent
    >
        <v-card>
            <v-form
                ref="form"
                v-model="form"
                @submit.prevent="submitForm"
            >
                <v-card-title style="background-color: #009688; color: white;">
                    New Diagnostic
                </v-card-title>
                <v-card-text>
                    <v-combobox
                        ref="diagnosticName"
                        key="rateType1"
                        v-model.trim="diagnosticName"
                        :items="getAcuDiagnosticSuggestions && getPackageDiagnosticsData && Array.isArray(getAcuDiagnosticSuggestions.data) ? getAcuDiagnosticSuggestions.data.filter(aItem => !getPackageDiagnosticsData.data.some(bItem => bItem.DIA_T.includes(aItem))) : []"
                        label="Diagnostic"
                        color="teal"
                        :rules="[v => v !== '' && v !== null && v !== undefined && /[a-zA-Z]/.test(v) || 'This field is required']"
                        clearable
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        width="120"
                        @click="showDialog = false"
                    >
                        <v-icon>{{ mdiClose }}</v-icon>
                        close
                    </v-btn>
                    <v-btn
                        color="teal darken-1"
                        width="120"
                        style="color: white;"
                        type="submit"
                        @mouseover="$refs.diagnosticName.blur()"
                    >
                        <v-icon>{{ mdiCheck }}</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiCheck
} from '@mdi/js'
export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        mdiClose,
        mdiCheck,
        form: false,
        newDiagnostic: {
            DIA_T: null
        },
        diagnosticName: null
    }),
    computed: {
        ...mapGetters(['addDiagnosticToPackageData', 'getAcuDiagnosticSuggestions', 'getPackageDiagnosticsData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$refs.form.reset()
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        addDiagnosticToPackageData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'New diagnostic has been saved.'
                    this.notif.show = true
                    this.getPackageDiagnostics({ RATE_ID: this.data.ID })
                    this.showDialog = false
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        }
    },
    methods: {
        ...mapActions(['addDiagnosticToPackage', 'getPackageDiagnostics']),
        submitForm() {
            if (this.$refs.form.validate()) {
                const arg = {
                    DIA_T: this.diagnosticName,
                    MSU_C: this.data.MSU_C,
                    RATE_ID: this.data.ID,
                    TYPE: this.data.MSU_TYPE
                }
                this.addDiagnosticToPackage(arg)
            }
        }
    }
}
</script>
